<template>
    <div class="_content" >
        <div class="top_bar" v-if="this.userRole === '老板' || this.userRole === '店长' ">
            <i @click="handleClick1(tabList1[0])" >查看店长和员工的区别></i>
        </div>
        <!-- 账号信息 -->
        <div class="user_type" v-if="this.userRole === '老板' || this.userRole === '店长' ">
            <van-cell-group>
                <!-- 输入框 -->
                <van-field
                    readonly
                    clickable
                    label="账号类型"
                    :value="addUser_val1"
                    placeholder="请选择"
                    @click="addUser_Picker1 = true"
                    input-align="right"
                    is-link
                />
                <van-popup v-model="addUser_Picker1" position="bottom">
                    <!-- 选择器 -->
                    <van-picker show-toolbar 
                    title="选择账号类型" 
                    :columns="addUser_columns1"   
                    @cancel="addUser_Picker1 = false"
                    @confirm="addUser_onConfirm1"
                    />
                </van-popup>
            </van-cell-group>

            <van-cell-group>
                <van-field input-align="right" 
                :formatter="formatter1" 
                v-model="addUser_val2" 
                label="员工姓名" 
                maxlength="4"
                placeholder="请输入" is-link />
            </van-cell-group>

            <van-cell-group>
                <van-field 
                input-align="right" 
                is-link  
                v-model="addUser_val3" 
                label="手机号码"  
                maxlength="11"
                placeholder="请输入" />
            </van-cell-group>
        </div>
     
        <div v-if="this.userRole === '老板' || this.userRole === '店长' ">
            <van-button @click="handleClick2(tabList1[1])" size="large" class="add_management_btn" color="rgb(25,137,250)" type="info">保存</van-button>
        </div>
        <van-empty image="error" v-if="this.userRole === '员工'" description="员工权限不足" />
    </div>
</template>
<script>
import config from '@/configs/config'
export default {
    data() {
        return {
            shopId: '',
            userRole: '',
            tabList1: [{
			name: '员工权限',
			url: '/pages/accountAccessPic/index'
            }, {
			name: '员工管理',
			url: '/pages/userManagement/index'
            }],
            addUser_val1: '',
            addUser_val2: '',
            addUser_val3: '',
            addUser_Picker1: false,
            addUser_columns1: [
                // 类型第一列
                {
                values: ['老板', '店长', '员工'],
                defaultIndex: 0
                }
            ]
        }
    },
    created() {
        this.getRoleData()
    },
    methods: {
        async getRoleData() {
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.userRole = roleData.data.role
                this.shopId = roleData.data.shopId
                if (this.userRole === '店长') {
                    this.addUser_columns1 = [{
                        values: ['店长', '员工'],
                        defaultIndex: 0
                    }]
                } else if (this.userRole === '员工') {
                    tuhu.toast('员工权限不足')
                }
            } else {
                tuhu.toast(roleData.message || '获取权限失败')
            }
        },
        handleClick1(item) {
                    tuhu.navigateTo({
                    url: item.url
                })
        },
        async handleClick2 (item) {
            let data = await tuhu.fetch(`${config.apis.ADD_USER_ACCOUNT}`, {
                method: 'post',
                body: JSON.stringify({
                    phone: this.addUser_val3,
                    role: this.addUser_val1,
                    shopId: this.shopId,
                    userAccount: this.addUser_val3, // 员工账号
                    userName: this.addUser_val2
                })
            })
            if (data && data.code === '200') {
                tuhu.toast(data.message || '操作成功')
                tuhu.navigateBack()
                // tuhu.navigateTo({
                //     url: item.url,
                //     query: {
                //         shopId: this.shopId
                //     }
                // })
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        },
        // 选择框
        addUser_onConfirm1(value) {
            this.addUser_val1 = value.toString()
            this.addUser_Picker1 = false
        },
        // 输入格式化
        formatter1(value) {
               // 过滤输入的数字
            return value.replace(/\d/g, '').replace(/\s/g, '')
        }
    }
}
</script>
<style lang="less" scoped>
    ._content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .user_type{
            width: 100%;
        }
        .top_bar{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 1.75rem;
            i{
                color:#097DD4;
            }
        }
    }
    .add_management_btn{
        width: 16rem;
        height: 2rem;
        .van-button__text{
            color: #fff;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/addAccessUser/index.vue